const buildNextUrl = ({ pathname, search, hash }) => `${pathname}${search}${hash}`;

export default buildNextUrl;
